import {action, computed, observable, toJS} from "mobx";
import {instance, mesAutobind} from "@posco/posco-shared";
import O10g014111Repository from "../repository/O10g014111Repository";
import O10g014112Repository from "../../o10g014112/repository/O10g014112Repository";

@mesAutobind
class O10g014111Stores {

  @instance(O10g014111Repository.instance)
  static instance;

  repository;

  constructor(repository) {
    this.repository = repository;
  }



  @observable
  _invpInfo = "";

  @computed
  get invpInfo() {
    return toJS(this._invpInfo);
  }

  @action
  clearInvpInfo() {
    this._invpInfo = "";
  }

  @action
  setInvpInfo(invpInfo) {
    this._invpInfo = invpInfo;
  }

  @action
  invbpInfoFind() {
    return O10g014111Repository.instance.invbpInfoFind()
      .then(action(result => {
        this._invpInfo = result;
      }));
  }

  @observable
  _invpInfoDetail = "";

  @computed
  get invpInfoDetail() {
    return toJS(this._invpInfoDetail);
  }

  @observable
  _userInfo = {};

  @computed
  get userInfo() {
    return toJS(this._userInfo);
  }

  @action
  clearInvpInfoDetail() {
    this._invpInfoDetail = "";
  }

  @action
  setInvpInfoDetail(invpInfoDetail) {
    this._invpInfo = invpInfoDetail;
  }

  @action
  invbpInfoFindDetail(type) {
    this.clearInvpInfoDetail();
    return O10g014111Repository.instance.invbpInfoFindDetail(type)
      .then(action(result => {
        this._invpInfoDetail = result;
      }));
  }

  @action
  clearUserInfo() {
    this._userInfo = "";
  }

  @action
  setUserInfo(userInfo) {
    this._userInfo = userInfo;
  }

  @action
  userInfoFind() {
    this.clearUserInfo();
    return O10g014111Repository.instance.userInfoFind()
      .then(action(result => {
        this._userInfo = result;
      }));
  }


}

export default O10g014111Stores;
